import React from 'react';
import fillIcon from '../../assets/enhance-nav-icon.png';
import classNames from 'classnames';
interface EnhanceNavIconProps {
    size: number;
    className?: string;
    style?: React.CSSProperties;
}

const EnhanceNavIcon: React.FC<EnhanceNavIconProps> = (props) => {
    const { className, style, size } = props;
    return (
        <img
            src={fillIcon}
            className={classNames('fx-enhance-nav-icon', className)}
            style={{ width: size, height: size, ...style }}
        />
    );
};

export default EnhanceNavIcon;
